export enum AlgoliaDataTypes {
  ACTS = 'Acts',
  VENUES = 'Venues',
  SHOWS = 'Shows',
  TICKETS = 'Tickets',
  THREADS = 'Threads',
  USERS = 'Users',
  REQUESTS = 'Requests',
  REVIEWS = 'Reviews',
  BEACONS = 'Beacons',
}

export enum AlgoliaIndices {
  ACTS = 'Acts',
  ACTS_CREATEDAT_DESC = 'Acts_publicAct.createdAt._seconds_desc',
  ACTS_LASTONLINEAT_DESC = 'Acts_publicAct.lastOnlineAt._seconds_desc',
  ACTS_NAME_ASC = 'Acts_publicAct.name_asc',
  ACTS_NUMSHOWSFINISHED_DESC = 'Acts_publicAct.numShowsFinished_desc',
  ACTS_NUMREVIEWS_DESC = 'Acts_publicAct.numReviews_desc',

  BEACONS = 'Beacons',
  BEACONS_CREATEDAT_DESC = 'Beacons_publicBeacon.createdAt._seconds_desc',
  BEACONS_STARTDATE_ASC = 'Beacons_publicBeacon.startDate._seconds_asc',
  BEACONS_SCORE_DESC = 'Beacons_publicBeacon.sortScore_desc',

  CONNECTIONS = 'Connections',

  REQUESTS = 'Requests',
  REQUESTS_STARTTIME_ASC = 'Requests_privateRequest.startTime._seconds_asc',
  REQUESTS_STARTTIME_DESC = 'Requests_privateRequest.startTime._seconds_desc',

  REVIEWS = 'Reviews',
  REVIEWS_CREATEDAT_DESC = 'Reviews_publicReview.createdAt._seconds_desc',

  SHOWS = 'Shows',
  SHOWS_CREATEDAT_DESC = 'Shows_publicShow.createdAt._seconds_desc',
  SHOWS_STARTTIME_ASC = 'Shows_publicShow.startTime._seconds_asc',

  THREADS = 'Threads',
  THREADS_THREADDATE_DESC = 'Threads_publicThread.threadDate._seconds_desc',

  TICKETS = 'Tickets',

  USERS = 'Users',

  VENUES = 'Venues',
  VENUES_CREATEDAT_DESC = 'Venues_publicVenue.createdAt._seconds_desc',
  VENUES_LASTONLINEAT_DESC = 'Venues_publicVenue.lastOnlineAt._seconds_desc',
  VENUES_NAME_ASC = 'Venues_publicVenue.name_asc',
  VENUES_NUMSHOWSFINISHED_DESC = 'Venues_publicVenue.numShowsFinished_desc',
  VENUES_NUMREVIEWS_DESC = 'Venues_publicVenue.numReviews_desc',
}

export enum ConnectionTypes {
  ARTIST = 'artist',
  HOST = 'venue',
  THREAD = 'thread',
}
